import { Position } from '../position';

export abstract class GeolocationService {
  abstract getCurrentPosition(): Promise<Position>;
}
